<template>
    <transition name="modal-fade">
        <div class="modal read-more">
            <div class="modal-dialog modal-dialog-centered read-more-dialog">
                <div class="row w-100 read-more-content">
                    <h2 class="donation-title mb-3" v-text="title"></h2>
                    <div class="donation-desc read-more-desc mb-4" v-text="content"></div>
                    <div class="d-flex justify-content-center w-100">
                        <button @click="closeModal" class="btn ok-btn px-5">
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    name: 'ReadMoreModal',
    props: {
        title: {
            type: String,
            default: '',
        },
        content: {
            type: String,
            default: '',
        },
    },
    methods: {
        closeModal() {
            this.$emit('close');
        },
    },
};
</script>

<style lang="scss" scoped>
.read-more {
    background-color: rgba(0, 0, 0, 0.5);
    &-dialog {
        max-width: 516px !important;
        width: 100%;
    }
    &-content {
        background-color: #fff;
        border-radius: 12px;
        padding: 20px;
        pointer-events: auto;
    }
    &-desc {
        max-height: 200px;
        overflow: auto;
    }
}
</style>
